import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AuthenticationService } from './services/authentication.service';
import { AdminAuthenticationService } from './services/admin-authentication.service';
import { HomeComponent } from './home.component';

const routes: Routes = [
    { path: 'member', loadChildren: './member/member.module#MemberModule', canActivate: [AuthenticationService] },
    { path: 'admin', loadChildren: './admin/admin.module#AdminModule', canActivate: [AdminAuthenticationService] },
    { path: 'member_update_login', loadChildren: './users/update/update.module#UpdateModule', canActivate: [AuthenticationService] },
    { path: 'admin_update_login', loadChildren: './users/update/update.module#UpdateModule', canActivate: [AdminAuthenticationService] },
    { path: 'signin', loadChildren: './users/signin/signin.module#SigninModule' },
    { path: 'register', loadChildren: './users/signup/signup.module#SignupModule' },
    { path: 'forgot', loadChildren: './users/forgot-password/forgot-password.module#ForgotPasswordModule' },
    { path: '', component: HomeComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
